<template>
  <div id="studentpaymentplan">
    <div class="container-fluid">
      <div>
        <div class="datatable-form__header atr-header-wrap mb-4">
          <div class="invoiceList-search_item">
            <el-select v-model="ddlAgent" placeholder="Select Agent" @change="agentchanged()" class="fullwidth">
              <el-option v-for="item in agentlist" :key="item.id" :label="item.Name" :value="item.Name"> </el-option>
            </el-select>
          </div>
          <div class="invoiceList-search_item">
            <el-select v-model="ddlSelectedAcademicYearID" placeholder="Select Academic Year" @change="getAgencyStudentList()" class="fullwidth">
              <el-option v-for="item in semesterList" :key="item.PK_Semester_ID" :label="item.SMT_Code" :value="item.SMT_Code"> </el-option>
            </el-select>
          </div>
        </div>

        <b-card no-body>
          <b-tabs
            active-nav-item-class="font-weight-bold text-uppercase text-danger"
            active-tab-class="font-weight-bold text-success"
            content-class="mt-3"
            card
          >
            <!-- Render this if no tabs -->
            <!--                        <div slot="empty" class="text-center text-muted">-->
            <!--                            <div class="empty-list_image"-->
            <!--                                 v-if="classListInt.length<1">-->
            <!--                                <strong>{{startupText}}</strong>-->
            <!--                                <img src="../assets/notfound.png"/>-->
            <!--                            </div>-->
            <!--                        </div>-->
          </b-tabs>

          <div v-if="fullListByClassNameObj.length > 0" class="datatable_group col-lg-12">
            <div class="datatable-form__submit text-left">
              <!--<button class="btn btn-success text-left" id="btnClassOverviewDownloadAll" v-on:click="DownloadAllClick(-1, 'All')">Download All</button><br><br>-->
            </div>

            <div v-for="(classBatchItem, i) in fullListByClassNameObj">
              <!--<label>Batch: {{classBatchItem[i].CLS_batch}}</label>-->
              <data-tables :data="classBatchItem">
                <el-table-column
                  v-for="studentItem in classBatchItemList"
                  :prop="studentItem.prop"
                  :label="studentItem.label"
                  :key="studentItem.prop"
                  sortable="custom"
                >
                </el-table-column>
              </data-tables>
              <div class="datatable-form__submit text-right" v-if="fullListByClassNameObj.length > 0">
                <button class="btn btn-success text-right" id="btnClassOverviewDownload" v-on:click="DownloadClick(ddlAgent, ddlSelectedAcademicYearID)">
                  Download</button
                ><br /><br />
              </div>
            </div>
          </div>

          <div class="empty-list_image" v-if="fullListByClassNameObj.length < 1">
            <strong>{{ startupText }}</strong>
            <img src="../assets/notfound.png" />
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import XLSX from 'xlsx'
export default {
  name: 'AgencyStudentList',

  async created() {
    await this.getAcademicYear()
    await this.getAgentList()
    //await this.getLevel();
    //await this.getClassType();
  },
  async mounted() {},
  data() {
    return {
      classBatch: '',
      classCount: 0,
      startupText: '',
      ddlSelectedAcademicYearID: '',
      ddlAgent: '',
      currentClassProgs: [],
      classListInt: [],
      totalNumberOfStudentAssignedToClass: '',
      agentlist: [],
      semesterList: [],
      ActiveSemesterList: [],
      classListSemesterID: '',
      classListCourseID: '',
      classListClassName: '',
      classListClassID: '',
      levelList: [],
      classTypeList: [],
      tempClassList: [],
      fullListByClassNameObj: [],

      classBatchItemList: [
        {
          prop: 'agentname',
          label: 'Agent Name',
        },
        {
          prop: 'studentno',
          label: 'Student No',
        },
        {
          prop: 'StudentName',
          label: 'Student Name',
        },
        {
          prop: 'totalcommission',
          label: 'Total Commission',
        },
        {
          prop: 'totalpaidcommission',
          label: 'Total Paid',
        },
        {
          prop: 'totalunpaidcommission',
          label: 'Total Unpaid',
        },
        {
          prop: 'academicyear',
          label: 'Academic Year',
        },
      ],
    }
  },
  methods: {
    clearTableList() {
      this.fullListByClassNameObj = []
    },

    async getAgentList() {
      try {
        const response = await DataSource.shared.getAgentList('', '', '')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.agentlist = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async getAcademicYear() {
      try {
        const response = await DataSource.shared.getAcademicYearforFourYears('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.semesterList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getLevel() {
      try {
        const response = await DataSource.shared.getLevel('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.levelList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getClassType() {
      try {
        const response = await DataSource.shared.getClassType('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.classTypeList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async getClass(semesterID) {
      try {
        this.tempClassList = []
        const response = await DataSource.shared.getClassIncludeClosed(semesterID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error!',
            })
            this.classListInt = []
          } else {
            this.tempClassList = response.Table
            await this.sortByClassName()
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async agentchanged() {
      this.ddlSelectedAcademicYearID = ''
      this.fullListByClassNameObj = []
    },

    async getAgencyStudentList() {
      //table?
      try {
        //validate
        if (this.ddlAgent == '') {
          this.$notify.error({
            title: 'Message',
            message: 'Please select an agent first',
          })

          this.ddlSelectedAcademicYearID = ''
          return
        }

        this.fullListByClassNameObj = []
        this.$vs.loading()

        const resp = await DataSource.shared.getAgencyStudentList(this.ddlAgent, this.ddlSelectedAcademicYearID)
        if (resp) {
          if (resp.Table) {
            this.fullListByClassNameObj.push(resp.Table)
          }
        }
      } catch (e) {
        this.results = e
      }

      this.$vs.loading.close()
    },

    async getSelectedAcademicYearValue() {
      try {
        await this.clearTableList()
        this.$vs.loading()

        await this.getClass(this.ddlSelectedAcademicYearID)

        //todo:To get 1st class list when academic year selected, Start
        //Reserved
        await this.getClassTabClick(this.classListInt[0].ArrObj_Items)
        //todo:To get 1st class list when academic year selected, End
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    async getStudentListByClassID(value) {
      try {
        this.fullListByClassNameObj = []
        this.$vs.loading()
        let classValue = this.ddlSelectedAcademicYearID + ',' + value.PK_Course_ID + ',' + value.PK_Class_ID
        const resp = await DataSource.shared.getClassStudentByClassIDIncludeInactive(classValue)
        if (resp) {
          if (resp.Table) {
            //console.log("this.fullListByClassNameObj=",this.fullListByClassNameObj);
            this.fullListByClassNameObj.push(resp.Table)
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    async getClassTabClick(objValue) {
      try {
        this.clearTableList()
        if (objValue) {
          console.log(objValue)
          objValue.forEach(m => {
            this.getStudentListByClassID(m)
          })
        } else {
          this.$notify.error({
            title: 'Message',
            message: 'Class not found!',
          })
        }
      } catch (e) {
        this.results = e
      }
    },

    async sortByClassName() {
      let tempArrList = []

      //want to slice the value if class name = '---'
      this.tempClassList.forEach(m => {
        if (m.Str_SortBy === '---') {
          m.slice(m.Str_SortBy, 1)
        }
        tempArrList.push(m)
      })
      //slice: to be cont
      let sortedList = this.groupBy(tempArrList, 'CLS_ClassName')

      this.classListInt = sortedList
    },

    groupBy(data, key) {
      //Credits to Ceasar Bautista and Juan Castillo @ stackoverflow
      /*return data.reduce(function(storage, item) {
                    let group = item[key];

                    storage[group] = storage[group] || [];
                    storage[group].push(item);
                    return storage;
                }, {});*/

      let ArrObj_Sorted = []

      for (let item of data) {
        let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key])

        if (index === -1) {
          ArrObj_Sorted.push({ Str_SortBy: item[key], ArrObj_Items: [item] })
        } else ArrObj_Sorted[index].ArrObj_Items.push(item)
      }

      return ArrObj_Sorted
    },

    exportExcel(title) {
      let exportExcelObject = []

      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '/')

      var mergedArrNormalWay = []

      this.fullListByClassNameObj.forEach(o => {
        o.forEach(so => mergedArrNormalWay.push(so))
      })

      mergedArrNormalWay.forEach(n => {
        let list = {
          'Agent Name': n.agentname,
          'Student No': n.studentno,
          'Student Name': n.StudentName,
          'Total Commission': n.totalcommission,
          'Total Paid': n.totalpaidcommission,
          'Total Unpaid': n.totalunpaidcommission,
          'Academic Year': n.academicyear,
        }
        exportExcelObject.push(list)
      })

      // console.log('exportExcelObject',exportExcelObject);

      var sheet1WS = XLSX.utils.json_to_sheet(exportExcelObject)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, sheet1WS, 'sheet1') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'AgencyStudentList - ' + currentDateWithFormat + ' - ' + title + '.xlsx') // name of the file is 'book.xlsx'
    },

    async DownloadClick(agent, title) {
      var fileid = agent + '_' + title
      this.exportExcel(fileid)
    },

    async DownloadAllClick(index, title) {
      this.exportExcel(title)
    },
  },
}
</script>

<style scoped></style>
